<template>
  <v-row justify="center">
    <v-spacer></v-spacer>
    <v-col cols="12" xs="12" sm="10" lg="8">
      <v-dialog v-model="dialog" persistent max-width="1300px">
        <v-card>
          <v-card-title>{{ title || 'Listini esterni' }}</v-card-title>
          <v-card-text>
            <v-data-table
              v-model="selected"
              :show-select="totaleDocumenti > 0"
              single-select
              item-key="_id"
              :headers="headers"
              :items="documenti"
              :options.sync="options"
              :loading="loading"
              class="elevation-1"
              :footer-props="{
                itemsPerPageOptions: [15, 50, 100]
              }"
              dense
            >
            <!-- 
              :server-items-length="totaleDocumenti" 
              :disable-sort="true"
            -->
            <template v-slot:top>
              <v-container fluent>
                <v-row no-gutters>
                  <v-col cols="3">Filtri</v-col>
                  <v-col cols="8" class="text--secondary">
                    <span>Imposta i filtri di visualizzazione</span>
                  </v-col>
                  <v-col cols="1"><v-btn color="success" @click.stop="onFiltra">Ricerca</v-btn></v-col>
                </v-row>            
                <v-row align="center" justify="space-around" dense>
                  <v-col cols="12" xs="12" sm="4" lg="3">
                    <v-combobox
                      v-model="filtri.marchio"
                      :loading="loading"
                      :items="itemsListini"
                      cache-items
                      no-data-text="Cerca un listino per Sigla o Descrizione"
                      dense chips small-chips flat outlined multiple
                      label="Produttore"
                      item-text="testo"
                      item-value="id"
                      clearable
                    >
                    </v-combobox>             
                  </v-col>
                  <v-col cols="12" xs="12" sm="6" lg="6">
                    <v-text-field v-model="filtri.testo" dense outlined label="Codice / descrizione" clearable  persistent-hint hint="Usa '%' per concatenare più parole non consecutive nella ricerca (es: porta % 400 % corpo)" @keydown="onKeyDown"></v-text-field>
                  </v-col>          
                  <v-spacer></v-spacer>
                </v-row> 
              </v-container>                
            </template>
            <template v-slot:[`footer.prepend`]>
              <v-btn color="success" @click="onImportaSelezionati" v-if="selected.length > 0">Importa selezionati</v-btn>
            </template>
            <template v-slot:[`item.Categoria`]="{ item, index }">
              <component :is="'pMultiselect'" v-if="itemSelezionato(item)" :item="itemCategoria(item)" :index="index" @change="componentValueChange" :suTable="true"/>
            </template>
<!--             <template v-slot:[`item.actions`]="{ item }">
              <v-icon small class="mr-2" title="Aggiungi all'archivio" @click="addItem(item)">mdi-plus</v-icon>
            </template> -->
            </v-data-table>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn @click="dialog = false">Chiudi</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-snackbar v-model="snackbar" :timeout="timeout" :color="snackColor">
        {{ snackText }}
        <template v-slot:action="{ attrs }">
          <v-btn  color="blue" text v-bind="attrs" @click="snackbar = false">
            OK
          </v-btn>
        </template>
      </v-snackbar>      
    </v-col>
    <v-spacer></v-spacer>
  </v-row>
</template>

<script>
  import _ from 'lodash'
  import { sanitize } from '@/helpers/sanitize'
  import configurazioni from '@/services/configurazioniService'
  import prodotti from '@/services/prodottiService'
  import esterni from '@/services/custom/esterniService'
  import pMultiselect from './multiselect'

  export default {
    components: {
      pMultiselect
    },
    props: {
      title: String,
      openSearch: Boolean
    },
    data: (vm) => ({
      panel: 0,
      dialog: false,
      totaleDocumenti: 0,
      documenti: [],
      selected: [],
      loading: true,
      options: {},
      headers: [
        { text: 'Marchio', value: 'SiglaMarchio', align: 'start'},
        { text: 'Codice', value: 'CodiceProdottoProduttore'},
        { text: 'Descrizione', value: 'DescrizioneProdotto' },
        { text: 'Categoria', value: 'Categoria' },
        { text: 'UM', value: 'UnitaDiMisura' },
        { text: 'Prz. Riv', value: 'PrezzoAlRivenditore' },
        { text: 'Prezzo', value: 'PrezzoAlPubblico' }
        /* { text: 'Actions', value: 'actions', sortable: false } */
      ],
      expanded: [],      
      filtri: {
        marchio: '',
        testo: ''
      },
      debounceSearch: null,
      searchListino: '',
      filtroListini: [],
      itemsListini: [],
      firstTime: false,
      snackbar: false,
      snackColor: '',
      snackText: '',
      timeout: 4000
    }),
    watch: {
      options: {
        async handler (value, old) {
          if (old.itemsPerPage && ((value.itemsPerPage !== old.itemsPerPage) || (value.page !== old.page))) {
            this.firstTime = true
          }
          if (!this.firstTime) {
            this.firstTime = true
          } else {
            await this.getDataFromApi()
          }
        },
        deep: true
      },
      async openSearch(value) {
        if (value) {
          this.firstTime = false
          await this.querySelections()
          this.dialog = true
        }
      }
    },
    computed: {
      unionFiltri() {
        let un = []
        if (this.filtri.marchio) {
          un.push(this.filtri.marchio)
        }
        if (this.filtri.testo) {
          un.push(this.filtri.testo)
        }
        return un
      }
    },
    methods: {
      itemSelezionato(item) {
        return this.selected.find(x => x._id === item._id)
      },
      itemCategoria(item) {
        return {
          "model": "Categoria",
          "valueField": "Categoria",
          "type": "Multiselect",
          "label": "Categoria1",
          "source": "prodotti_categorie.categorie.categoria1",
          "required": false,
          "addForbidden": false,
          value: _.get(item, 'Categoria', '') 
        }
      },
      async InviaScelta(selezionati) {
        const esistenti = []
        for (let s of selezionati) {
          let esistente = await prodotti.getProdotto(sanitize(s._id))
          if (esistente) {
            esistente.PrezzoAlPubblico = s.PrezzoAlPubblico // Per aggiornamento prezzo su prodotto salvato. Eventualmente aggiungere altri valori da aggiornare
            esistenti.push(esistente)
            selezionati = selezionati.filter(x => x._id !== s._id)
          } else if (!s.Categoria) {
            this.snackColor = 'red accent-2'
            this.snackText = 'E\' necessario impostare la categoria di tutti i prodotti selezionati'
            this.snackbar = true
            return
          }
        }
        if (esistenti.length > 0) {
          this.snackColor = 'info'
          this.snackText = 'Alcuni prodotti sono già esistenti e verranno aggiunti direttamente al documento'
          this.snackbar = true
        }
        this.$emit('importaEsterno', { nuoviArticoli: selezionati, esistenti })
        this.dialog = false
      },
      async addItem(item) {
        let selezionati = [item]
        await this.InviaScelta(selezionati)
        /* const esistenti = []
        for (let s of selezionati) {
          debugger
          const esistente = await prodotti.getProdotto(sanitize(s._id))
          if (esistente) {
            esistenti.push(esistente)
            selezionati = selezionati.filter(x => x._id !== s._id)
          } else if (!s.Categoria) {
            this.snackColor = 'red accent-2'
            this.snackText = 'E\' necessario impostare la categoria di tutti i prodotti selezionati'
            this.snackbar = true
            return
          }
        }
        if (esistenti.length > 0) {
          this.snackColor = 'info'
          this.snackText = 'Alcuni prodotti sono già esistenti e verranno aggiunti direttamente al documento'
          this.snackbar = true
        }
        this.$emit('importaEsterno', { nuoviArticoli: selezionati, esistenti })
        this.dialog = false */
      },
      async onImportaSelezionati() {
        let selezionati = this.selected
        await this.InviaScelta(selezionati)
/*         const esistenti = []
        for (let s of selezionati) {
          debugger
          const esistente = await prodotti.getProdotto(sanitize(s._id))
          if (esistente) {
            esistenti.push(esistente)
            selezionati = selezionati.filter(x => x._id !== s._id)
          } else if (!s.Categoria) {
            this.snackColor = 'red accent-2'
            this.snackText = 'E\' necessario impostare la categoria di tutti i prodotti selezionati'
            this.snackbar = true
            return
          }
        }
        if (esistenti.length > 0) {
          this.snackColor = 'info'
          this.snackText = 'Alcuni prodotti sono già esistenti e verranno aggiunti direttamente al documento'
          this.snackbar = true
        }
        this.$emit('importaEsterno', { nuoviArticoli: selezionati, esistenti })
        this.dialog = false */
      },
      async onKeyDown(event) {
        if (event.keyCode === 13) {
          await this.onFiltra()
        }
      },
      async onFiltra() {
        this.options.page = 0
        this.firstTime = false
        await this.getDataFromApi()
      },
/*       async searchProdottoDeb(val) {
        if (val) {
          await this.getDataFromApi(val)
        }
      }, */      
      async getDataFromApi () {
        try {
          this.loading = true
          const locFiltro = this.filtri
          let filtri = {
            testo: locFiltro.testo || '',
            marchi: locFiltro.marchio && locFiltro.marchio.map(x => x.id)
          }
          if (filtri.testo) {
            filtri.testo = filtri.testo.split('%').join('&') // TODO: Mettere codice su Impostazioni
          }
          const data = await esterni.cerca(filtri, this.options)
          this.documenti = data && data.total_rows > 0 ? data.rows : []
          this.totaleDocumenti = data.total_rows
        } catch(err) {
          this.documenti = []
          this.totaleDocumenti = 0
        } finally {
          this.loading = false
        }
      },
/*       async searchListinoDeb() {
        if () {
          await this.querySelections()
        }
      }, */
      async querySelections () {
        this.loading = true
        const listini = await configurazioni.getConfigurazione('file_esterni', 'caricati')
        this.itemsListini = listini.map(x => {
          return {
            id: x.codice,
            testo: x.marchio.descrizione
          }
        })
/*         const data = await esterni.elencoListini()
        const cp = data && data.rows
        this.itemsListini = cp.filter(x => x.key.length > 0).map(x => {
          const id = x.key[0]
          const testo = x.key[0]
          return { 
            testo: testo,
            id: id
          }
        }) */
        this.loading = false
      },
      async componentValueChange(data) {
        const { model, value, index } = data
        let documento = this.documenti[index]
        _.set(documento, model, value)
        
      }      
    }    
  }

</script>
